import { render, staticRenderFns } from "./ShakaPlayer.vue?vue&type=template&id=ad597f5a&scoped=true&"
import script from "./ShakaPlayer.vue?vue&type=script&lang=js&"
export * from "./ShakaPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad597f5a",
  null
  
)

export default component.exports